// Module
var code = "You should begin this story in the place you consider to be your home. When you're there you should just tap the button below...";
// Exports
module.exports = code;